import { render, staticRenderFns } from "./ConfirmClearCustomer.vue?vue&type=template&id=339bafe2&scoped=true"
import script from "./ConfirmClearCustomer.vue?vue&type=script&lang=ts"
export * from "./ConfirmClearCustomer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339bafe2",
  null
  
)

export default component.exports